$(document).on('shopify:section:load', function() {
    if ($('.contact-info').length) {
        $('.contact-info').each(function() {
            let contactText = $(this).find('.info');

            contactText.html(function(_, html) {
                return html.replace(
                    /([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/g,
                    '<a href="mailto:$1">$1</a>'
                );
            });
        });
    }

    contact_info();
    contact_form();
});

$(document).ready(function() {
    if ($('.contact-info').length) {
        $('.contact-info').each(function() {
            let contactText = $(this).find('.info');

            contactText.html(function(_, html) {
                return html.replace(
                    /([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/g,
                    '<a href="mailto:$1">$1</a>'
                );
            });
        });
    }

    contact_info();
    contact_form();
});

$(window).on('scroll', function() {
    contact_info();
    contact_form();
});

function contact_info() {
    if ($('.contact-info').length) {
        $('.contact-info').each(function() {
            let el = $(this);
        
            if (visiblePercent(el) > 20) {
                el.find('.aos-init').addClass('aos-animate');
            } else {
                el.find('.aos-init').removeClass('aos-animate');
            }
        });    
    }
}

function contact_form() {
    if ($('.contact-form').length) {
        $('.contact-form').each(function() {
            let el = $(this);
        
            if (visiblePercent(el) > 20) {
                el.find('.aos-init').addClass('aos-animate');
            } else {
                el.find('.aos-init').removeClass('aos-animate');
            }
        });    
    }
}